module.exports = __webpack_public_path__ + "static/media/video2.129b5a9e.png";